import React from 'react';

import { useTranslation } from 'react-i18next';
import { Control, Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';

interface IStateControllerProps {
    name: string;
    control: Control;
    defaultValue: string;
    controlClassName?: string;
    country?: string | null;
    size?: 'sm' | 'lg';
    disabled?: boolean;
}

export const StateController = ({name, control, controlClassName, country, size, disabled}: IStateControllerProps) => {
    const {t} = useTranslation();

    const placeholder = t('common.state', 'State');

    const stateOptions = React.useMemo(() => {
        if (country === 'AU') {
            return (
                <>
                    <option value="NSW">
                        {t('localities.australia.state.newSouthWales', 'New South Wales')}
                    </option>
                    <option value="VIC">
                        {t('localities.australia.state.victoria', 'Victoria')}
                    </option>
                    <option value="QLD">
                        {t('localities.australia.state.queensland', 'Queensland')}
                    </option>
                    <option value="WA">
                        {t('localities.australia.state.westernAustralia', 'Western Australia')}
                    </option>
                    <option value="SA">
                        {t('localities.australia.state.southAustralia', 'South Australia')}
                    </option>
                    <option value="TAS">
                        {t('localities.australia.state.tasmania', 'Tasmania')}
                    </option>
                </>
            );
        } else {
            return null;
        }
    }, [t, country]);

    return (
        <Controller
            name={name}
            control={control}
            render={(
                {onChange, onBlur, value, ref},
                {invalid}
            ) => stateOptions ? (
                <Form.Control
                    custom
                    as="select"
                    className={controlClassName}
                    name={name}
                    value={value}
                    isInvalid={invalid}
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.value)}
                    ref={ref}
                    size={size}
                    disabled={disabled}
                >
                    <option value="">
                        {placeholder}
                    </option>
                    {stateOptions}
                </Form.Control>
            ) : (
                <Form.Control
                    type="text"
                    name={name}
                    className={controlClassName}
                    defaultValue={value}
                    isInvalid={invalid}
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.value)}
                    ref={ref}
                    placeholder={placeholder}
                    size={size}
                    disabled={disabled}
                />
            )}
        />
    );
};

StateController.defaultProps = {
    defaultValue: 'AU',
};
